/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_A2Inputs */

const en_to_csv_faq_a2 = /** @type {(inputs: To_Csv_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They are serialized as JSON text inside a single cell, then quoted because that text contains double quotes. They are not expanded into separate columns.`)
};

const ko_to_csv_faq_a2 = /** @type {(inputs: To_Csv_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`한 칸 안에 JSON 텍스트로 직렬화되고, 그 텍스트에 큰따옴표가 있으므로 인용됩니다. 별도의 열로 펼쳐지지는 않습니다.`)
};

const ja_to_csv_faq_a2 = /** @type {(inputs: To_Csv_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 つのセルの中に JSON テキストとしてシリアライズされ、そのテキストに二重引用符があるので引用されます。別々の列には展開されません。`)
};

/**
* | output |
* | --- |
* | "They are serialized as JSON text inside a single cell, then quoted because that text contains double quotes. They are not expanded into separate columns." |
*
* @param {To_Csv_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_a2 = /** @type {((inputs?: To_Csv_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_a2(inputs)
	if (locale === "ko") return ko_to_csv_faq_a2(inputs)
	return ja_to_csv_faq_a2(inputs)
});